// extracted by mini-css-extract-plugin
export default {"loader":"loader--pyadU","loader__svg":"loader__svg--TGbBS","loaderSvg":"loader__svg--TGbBS"};